import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class DeleteAnnouncementsAction implements Action {
  public static readonly type = 'DeleteAnnouncementsAction';

  constructor(public bijbEvent: BijbEvent, public announcementIds: number[]) {
  }

  public type = DeleteAnnouncementsAction.type;
}
